import { useParams } from "react-router-dom";
import { accountText } from "./_accountText";

export default function Addresses(){
  const { lang = "en" } = useParams();
  const copy = accountText(lang);
  return <div><h1 className="text-2xl font-black">{copy.addresses}</h1><p className="mt-2 text-slate-600">{copy.addressesBody}</p></div>;
}
